module.exports = __webpack_public_path__ + "img/category-add.667c6a25.svg";